import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import Geocode from "react-geocode";

import activeIcon from "./imgs/active.png";

var mapKey = false;
const containerStyle = {
    position: "relative",
    minWidth: "100%",
    height: "50VH",
    minHeight: "400",
};
export class InfoWindowEx extends Component {
    constructor(props) {
        super(props);
        this.infoWindowRef = React.createRef();

        if (!this.containerElement) {
            this.containerElement = document.createElement(`div`);
        }
    }

    onInfoWindowOpen = () => {
        ReactDOM.render(
            React.Children.only(this.props.children),
            this.containerElement
        );
        this.infoWindowRef.current.infowindow.setContent(this.containerElement);
    };
    render() {
        return (
            <InfoWindow
                onOpen={this.onInfoWindowOpen}
                ref={this.infoWindowRef}
                {...this.props}
            />
        );
    }
}

class MapContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lat: 0,
            lng: 0,
            markerName: "",
            showingInfoWindow: false,
            activeMarker: {},
            selectedPlace: {},
            report: false,
        };
        mapKey = props.mapKey;

        Geocode.setApiKey(mapKey);
    }

    getMarkers = (jobList) => {
        return Object.keys(jobList).map((job, i) => {
            let iconMarker = new window.google.maps.MarkerImage(
                activeIcon,
                null /* size is determined at runtime */,
                null /* origin is 0,0 */,
                null /* anchor is bottom center of the scaled image */,
                new window.google.maps.Size(20, 20)
            );

            return (
                <Marker
                    icon={iconMarker}
                    key={i}
                    title={jobList[job].report_type}
                    position={{
                        lat: jobList[job].location_lat,
                        lng: jobList[job].location_lon,
                    }}
                    // style={{ display: "block" }}
                    name={jobList[job].job_id}
                    onClick={(props, marker, e) => {
                        this.setState({
                            selectedCoord: {
                                lat: jobList[job].location_lat,
                                lng: jobList[job].location_lon,
                            },
                            selectedPlace: props,
                            activeMarker: marker,
                            showingInfoWindow: true,
                            report: jobList[job],
                        });
                    }}
                />
            );
        });
    };
    gotolink = () => {
        this.props.redirect(
            `/job-pack-view/jobpacks/${this.props.st}/${this.props.year}/${this.props.month}/${this.state.jobID}`
        );
    };
    render() {
        const { jobList, reportTypes, usernames } = this.props;

        return (
            <div
                ref={"map"}
                style={{ position: "relative", width: "100%", height: "400px" }}
            >
                <Map
                    style={{
                        border: "1px solid rgb(195, 207, 214)",
                        minWidth: "100%",
                        height: 380,
                    }}
                    google={this.props.google}
                    initialCenter={
                        this.state.selectedCoord
                            ? this.state.selectedCoord
                            : {
                                  lat: 53.3020686,
                                  lng: -7.4909908,
                              }
                    }
                    zoom={7}
                    center={
                        this.state.selectedCoord
                            ? this.state.selectedCoord
                            : {
                                  lat: 53.3020686,
                                  lng: -7.4909908,
                              }
                    }
                    containerStyle={containerStyle}
                    onClick={() => {
                        if (this.state.showingInfoWindow) {
                            this.setState({
                                showingInfoWindow: false,
                                activeMarker: null,
                            });
                        }
                    }}
                >
                    {jobList && this.getMarkers(jobList)}
                    <InfoWindowEx
                        marker={this.state.activeMarker}
                        visible={this.state.showingInfoWindow}
                    >
                        {this.state.report && (
                            <div
                                style={{
                                    textAlign: "center",
                                    marginTop: 20,
                                    padding: 10,
                                    width: "100%",
                                }}
                            >
                                <p>
                                    <b>Report Type:</b>{" "}
                                    {reportTypes
                                        ? reportTypes[
                                              this.state.report.report_type
                                          ]
                                        : "N/A"}
                                </p>
                                <p>
                                    <b>Username:</b>{" "}
                                    {usernames
                                        ? usernames[this.state.report.uid]
                                        : "N/A"}
                                </p>
                                <p>
                                    <b>Job ID:</b>{" "}
                                    {this.state.report.subject_name.includes(
                                        "jobpacks"
                                    )
                                        ? this.state.report.subject_child
                                        : "N/A"}
                                </p>
                                <p>
                                    <b>Timestamp</b>{" "}
                                    {this.state.report.timestamp
                                        ? this.state.report.timestamp
                                        : "N/A"}
                                </p>
                            </div>
                        )}
                    </InfoWindowEx>
                </Map>
            </div>
        );
    }
}

export default GoogleApiWrapper((props) => ({
    apiKey: props.mapKey,
}))(MapContainer);
